import onDismissModal from './message-handlers/on-dismiss-modal';
import { MESSAGE_TYPES } from './constants';
import onGoBack from './message-handlers/on-go-back';
import onNavButtonPressed from './message-handlers/on-app-nav-button-pressed';
import onActionSheetButtonPressed from './message-handlers/on-app-action-sheet-item-pressed';
import onDialogDismissed from './message-handlers/on-app-dialog-dismissed';

export default {
  [MESSAGE_TYPES.GO_BACK]: onGoBack,
  [MESSAGE_TYPES.NAV_BUTTON_PRESSED]: onNavButtonPressed,
  [MESSAGE_TYPES.ACTION_SHEET_ITEM_PRESSED]: onActionSheetButtonPressed,
  [MESSAGE_TYPES.DISMISS_MODAL]: onDismissModal,
  [MESSAGE_TYPES.DIALOG_DISMISSED]: onDialogDismissed,
};
